import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import PageAx                from 'app/actions/company-admin/page-wallet';
import Icon                  from 'app/components/common/icon';
import Meta                  from 'app/components/common/meta';
import CadminLayout          from 'app/components/company-admin/layout/';
import DirectUploadBox       from 'app/components/company-admin/wallet/direct-upload-box';
import ModalAssignPm         from 'app/components/company-admin/wallet/modal-assign-pm';
import ModalCreditCard       from 'app/components/company-admin/wallet/modal-credit-card';
import ModalMigrate          from 'app/components/company-admin/wallet/modal-migrate-bank-account';
import ModalNewPm            from 'app/components/company-admin/wallet/modal-new-payment-method';
import ProgramSettings       from 'app/components/company-admin/wallet/program-settings';
import PageLoading           from 'app/components/layout/page-loading';
import format                from 'app/helpers/format';
import history               from 'app/history';
import paths                 from 'app/paths';
import prompts               from 'app/prompts';
import CadminSlx             from 'app/selectors/company-admin/';
import PageSlx               from 'app/selectors/company-admin/page-wallet';
import FfSlx                 from 'app/selectors/feature-flags';
import RoutingSlx            from 'app/selectors/routing';



class PageCadminWallet extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      ccModalOpen: false,
      showNewPmModal: false,
      migrateBankAccountId: null,
    };

    this.onClickNewPm = this.onClickNewPm.bind(this);
    this.onCloseNewPm = this.onCloseNewPm.bind(this);    
    this.onClickAddCc = this.onClickAddCc.bind(this);
    this.onCloseCcModal = this.onCloseCcModal.bind(this);
    this.onClickMigrateBa = this.onClickMigrateBa.bind(this);
    this.onCloseMigrate = this.onCloseMigrate.bind(this);
  }

  componentDidMount() {
    const {query, params, showBa} = this.props;
    if (query.bankAccountId) {
      const newPath = paths.cadminWallet(params.companySlug, _.omit(query, ['bankAccountId']));
      history.replace(newPath);
      showBa(query.bankAccountId);
    }
  }

  get migrateBankAccount() {
    const {migrateBankAccountId} = this.state;
    const {bankAccounts} = this.props;
    if (!migrateBankAccountId || !bankAccounts) return null;
    return bankAccounts.find(ba => ba.id === migrateBankAccountId) || null;
  }

  onClickMigrateBa(ba) {
    this.setState({migrateBankAccountId: ba.id});
  }
  onCloseMigrate() {
    this.setState({migrateBankAccountId: null});
  }

  onClickNewPm() {
    this.setState({showNewPmModal: true});
  }
  onCloseNewPm() {
    this.setState({showNewPmModal: false});
  }

  onClickAddCc() {
    this.setState({ccModalOpen: true});
  }

  onCloseCcModal({didCreate} = {}) {
    this.setState({ccModalOpen: false});
    if (didCreate) this.props.fetchCcs();
  }

  async onClickRemoveCc(cc) {
    const msg = `Are you sure you want to delete this credit card?\n${cc.accountLabel}\nNOTE: Any programs this card is assigned to will not be able to process payments until a new payment method is assigned.`;
    const didConfirm = await prompts.confirm({msg, danger: 'Delete'});
    if (didConfirm) {
      this.props.deleteCc(cc.id);
    }
  }

  async onClickRemoveBa(ba) {
    const msg = `Are you sure you want to delete this bank account?\n${ba.accountLabel}\nNOTE: Any programs this bank account is assigned to will not be able to process payments until a new payment method is assigned.`;
    const didConfirm = await prompts.confirm({msg, danger: 'Delete'});
    if (didConfirm) {
      this.props.deleteBa(ba.id);
    }
  }

  renderStatusElements(ba) {
    const {verified, setupFailed, setupFailedMessage, requiresMigration, isStripeLegacy, stripeVerificationUrl} = ba;
    const status = (() => {
      if (setupFailed) return 'error';
      if (!verified) return 'verify';
      if (requiresMigration) return 'migrate';
      return 'success';
    })();
    const statusLabel = ({
      error: 'Setup Failed',
      verify: 'Pending',
      migrate: 'Action Required',
      success: 'Linked',
    })[status];
    const badge = <div className={`ca-wallet-pm-desc-status ${status}`}>{statusLabel}</div>;
    const ctaBtnClass = 'ca-wallet-pm-cta-btn btn blue small';
    const cta = (() => {
      if (status === 'error') {
        return <>
          <p className="ca-wallet-pm-error">Unable to connect this bank account. Please remove and try again.</p>
          {!!setupFailedMessage && <p className="ca-wallet-pm-error">{`Message from Stripe: ${setupFailedMessage}`}</p>}
        </>;
      }
      if (status === 'verify') {
        if (!stripeVerificationUrl) return null;
        return <a href={stripeVerificationUrl} target="_blank" className={ctaBtnClass}>Enter Micro Deposits</a>;
      }
      if (status === 'migrate') {
        return <button className={ctaBtnClass} onClick={this.onClickMigrateBa.bind(this, ba)}>Review</button>;
      }
      return null;
    })();
    return [badge, cta];
  }

  renderPaymentMethods() {
    const { creditCards, ccsLoading, bankAccounts, basLoading } = this.props;

    return (
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Company Payment Methods</h1>
        </div>
        <div className="ca-box-body">
          {ccsLoading ? <Icon.Loading className="ca-wallet-pm-loading" /> : creditCards.map((cc) => {
            const expiration = moment.utc(`${cc.expYear}-${cc.expMonth}-2`, 'YYYY-M-D').format('MM/YYYY');
            return (
              <div key={cc.id} className="ca-wallet-pm ca-wallet-cc">
                <div className="ca-wallet-pm-data-contain">
                  <div className="ca-wallet-pm-type">Credit Card</div>
                  <div className="ca-wallet-pm-desc">
                    <Icon.CreditCard brand={cc.brand} />
                    <strong>{format.ccBrandName(cc.brand)} **{cc.last4}</strong>
                    <span className="faint">
                      &nbsp; exp: {expiration}
                      &nbsp; zip: {cc.addressZip}
                    </span>
                  </div>
                  <button className="ca-wallet-pm-delete" onClick={this.onClickRemoveCc.bind(this, cc)}><Icon.Bin /></button>
                </div>
              </div>
            );
          })}
          {basLoading ? <Icon.Loading className="ca-wallet-pm-loading" /> : bankAccounts.map((ba) => {
            const [statusBadge, statusCta] = this.renderStatusElements(ba);
            return (
              <div key={ba.id} className="ca-wallet-pm ca-wallet-ba">
                <div className="ca-wallet-pm-data-contain">
                  <div className="ca-wallet-pm-type">Bank Account</div>
                  <div className="ca-wallet-pm-desc">
                    <Icon.SavingBank />
                    <strong>{ba.accountLabel}</strong>
                    {statusBadge}
                  </div>
                  <button className="ca-wallet-pm-delete" 
                    onClick={this.onClickRemoveBa.bind(this, ba)}>
                    <Icon.Bin />
                  </button>
                </div>
                {statusCta}
              </div>
            );
          })}
          <div className="ca-wallet-pm-buttons">
            <button className="btn slate" onClick={this.onClickAddCc}>Add Credit Card</button>
            <button className="btn slate" onClick={this.onClickNewPm}>Add Bank Account</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {company, creditCards, verifiedBankAccounts} = this.props;
    if (!company) return <PageLoading />;
    
    const {ccModalOpen, showNewPmModal} = this.state;

    const balanceAmount = company.balance?.amount || 0;
    const formattedBalance = format.usd(balanceAmount);

    return (
      <CadminLayout className="ca-wallet" company={company} activeItem="wallet">
        <Meta title="Wallet | Millie" />
        <div className="ca-page-header">
          <h1 className="ca-page-header-title">Company Wallet</h1>
          <div className="ca-wallet-balance">
            <div className="ca-wallet-balance-amount">{formattedBalance}</div>
            <div className="ca-wallet-balance-label">Left to Use</div>
          </div>
        </div>
        <div className="ca-wallet-cols">
          <div className="ca-wallet-cols-left">
            {this.renderPaymentMethods()}
            <p className="ca-wallet-program-settings-heading">Which payment method would you like to use for each giving type?</p>
            <ProgramSettings type="match" />
            {company.features.gift && (
              <ProgramSettings type="gift" />
            )}
            <ProgramSettings type="grant" />
            {company.features.payroll && (
              <ProgramSettings type="payroll" hideBalanceFirst />
            )}
            {company.features.vol && (
              <ProgramSettings type="dfd" />
            )}
          </div>
          <div className="ca-wallet-cols-right">
            <DirectUploadBox paymentMethods={[...creditCards, ...verifiedBankAccounts]} />
          </div>
        </div>
        {ccModalOpen && (
          <ModalCreditCard onClose={this.onCloseCcModal} />
        )}
        {showNewPmModal && (
          <ModalNewPm company={company} onClose={this.onCloseNewPm} />
        )}
        {!!this.migrateBankAccount && (
          <ModalMigrate bankAccount={this.migrateBankAccount} company={company} onClose={this.onCloseMigrate} />
        )}
        <ModalAssignPm />
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  query: RoutingSlx.query(state),
  params: RoutingSlx.params(state),

  creditCards: PageSlx.creditCards(state),
  ccsLoading: PageSlx.ccsLoading(state),

  bankAccounts: PageSlx.bankAccounts(state),
  basLoading: PageSlx.basLoading(state),

  verifiedBankAccounts: PageSlx.verifiedBankAccounts(state),
});

const dispatchToProps = (dispatch) => ({
  fetchCcs: () => dispatch(PageAx.fetchCreditCards()),
  deleteCc: (ccId) => dispatch(PageAx.deleteCreditCard(ccId)),
  deleteBa: (baId) => dispatch(PageAx.deleteBankAccount(baId)),
  showBa: (baId) => dispatch(PageAx.showBankAccount(baId)),
});

export default connect(stateToProps, dispatchToProps)(PageCadminWallet);
